<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-xl-12 mb-5">
      <dashboard-box :title="$t('general.filter')">
        <template v-slot:preview>
          <div class="row">
            <div class="col-lg-4 col-xl-4">
              <b-form-group :label="$t('users.start_date')" label-for="input-2">
                <b-form-input
                    class="form-control form-control-solid"
                    type="date"
                    required
                    :placeholder="$t('users.start_date')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-xl-4">
              <b-form-group :label="$t('users.end_date')" label-for="input-2">
                <b-form-input
                    class="form-control form-control-solid"
                    type="date"
                    required
                    :placeholder="$t('users.end_date')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-xl-4">
              <b-form-group :label="$t('users.member_id')" label-for="input-2">
                <b-form-input
                    class="form-control form-control-solid"
                    type="text"
                    required
                    :placeholder="$t('users.member_id')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-8 col-xl-8">
              <b-form-group :label="$t('fraud_management.groups')">
                <b-form-checkbox-group
                    id="checkbox-group-1"
                    v-model="selected_group"
                    :options="groups"
                    name="flavour-1"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-xl-4">
              <b-form-group :label="$t('fraud_management.get_sub_users')">
                <b-form-checkbox-group id="checkbox-group-2" v-model="filter.get_sub_users" name="flavour-2">
                  <b-form-checkbox value="orange">{{ $t('general.yes') }}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </template>
        <template v-slot:foot>
          <span class="fa-pull-right">
            <button type="reset" class="btn btn-outline-primary mr-10">{{ $t('general.clear') }}</button>
            <button type="submit" class="btn btn-primary">{{ $t('general.filter_') }}</button>
          </span>
        </template>
      </dashboard-box>
    </div>
    <div class="col-lg-12 col-xl-12 col-sm-12 mb-5">
      <dashboard-box :title="$t('fraud_management.results')">
        <template v-slot:toolbar>
          <b-input-group class="mt-3">
            <button type="submit" class="btn btn-outline-success mr-10"><i class="far fa-file-excel"></i> {{ $t('contact_requests.import_excel') }}</button>
            <b-form-select v-model="user_type" :options="user_types"></b-form-select>
            <b-input-group-append>
              <button @click="submit" type="submit" class="btn btn-primary">{{ $t('general.update') }}</button>
            </b-input-group-append>
          </b-input-group>
        </template>
        <template v-slot:preview>
          <data-table
              :items="table.items"
              :fields="report.fields"
              :paginate="report.paginate"
              page.sync="3"
              perPage.sync="10"
          ></data-table>
        </template>
      </dashboard-box>
    </div>

  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";

export default {
  name: "FraudManagement",
  components: { DataTable, DashboardBox },
  methods: {

    submit(){
      Swal.fire({
        title: "",
        text: "Güncelleme başarılı.",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText: "Tamam"
      });
    }

  },
  data() {
    return {
      filter : {
        get_sub_users : true
      },
      user_type : null,
      user_types: [{ text: this.$t('general.select'), value: null }, 'Yeni Üye','Aktif Üye','Pasif Üye','Fraud Yapan Üye','Fraud Üyelik','Çöp',"ST'de Silinmeyi İsteyen","Napolyon'da Silinmeyi İsteyen",],
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'checkbox', label: '', sortable: false},
          {key: 'parent_member_id', label: 'Parent Mmb ID', sortable: false},
          {key: 'parent_member', label: 'Parent Mmb', sortable: false},
          {key: 'member_id', label: 'Üye ID', sortable: true},
          {key: 'firstname', label: 'Ad', sortable: true},
          {key: 'lastname', label: 'Soyad', sortable: true},
          {key: 'email', label: 'Email', sortable: true},
          {key: 'point', label: 'Puan', sortable: true},
          {key: 'registered_at', label: 'Kayıt Tarihi', sortable: true},
          {key: 'registered_ip', label: 'Kayıt IP', sortable: true},
          {key: 'gsm', label: 'Gsm', sortable: true},
          {key: 'birthdate', label: 'Doğum Tarihi', sortable: true},
          {key: 'member_status', label: 'Aktif Üye', sortable: true},
          {key: 'level1_count', label: 'Level 1', sortable: true},
          {key: 'tc', label: 'T.C. No', sortable: true},
          {key: 'city_id', label: 'Şehir Kodu', sortable: true},
          {key: 'city_name', label: 'Şehir Adı', sortable: true},
          {key: 'education_level', label: 'Eğitim', sortable: true},
          {key: 'granduation', label: 'Mezuniyet', sortable: true},
          {key: 'parent_city_id', label: 'Parent Şehir ID', sortable: true},
          {key: 'gender', label: 'Cinsiyet', sortable: true},
          {key: 'marial_status', label: 'Medeni Durumu', sortable: true},
          {key: 'partner_status', label: 'Partner Durumu', sortable: true},
        ],
      },
      table : {
        items : [
          {
            'member_id' : '17898',
            'firstname' : 'Bekir',
            'lastname' : 'Uca',
            'email' : 'bekiroca@test.com',
            'point' : '12400',
            'registered_at' : '4.01.2021 13:00',
            'registered_ip' : '178.912.14.14',
            'gsm' : '0555 555 55 55',
            'birthdate' : '11.12.1999',
            'member_status' : 'Aktif',
            'level1_count' : '0',
            'tc' : '',
            'city_id' : '34',
            'city_name' : 'İstanbul',
            'education_level' : 'Normal Lise',
            'granduation' : 'Öğrenci',
            'parent_city_id' : '',
            'gender' : 'Kadın',
            'marial_status' : 'Bekar',
            'partner_status' : 'N/A',
          },
          {
            'member_id' : '17898',
            'firstname' : 'Bekir',
            'lastname' : 'Uca',
            'email' : 'bekiroca@test.com',
            'point' : '12400',
            'registered_at' : '4.01.2021 13:00',
            'registered_ip' : '178.912.14.14',
            'gsm' : '0555 555 55 55',
            'birthdate' : '11.12.1999',
            'member_status' : 'Aktif',
            'level1_count' : '0',
            'tc' : '',
            'city_id' : '34',
            'city_name' : 'İstanbul',
            'education_level' : 'Normal Lise',
            'granduation' : 'Öğrenci',
            'parent_city_id' : '',
            'gender' : 'Kadın',
            'marial_status' : 'Bekar',
            'partner_status' : 'N/A',
          },
          {
            'member_id' : '17898',
            'firstname' : 'Bekir',
            'lastname' : 'Uca',
            'email' : 'bekiroca@test.com',
            'point' : '12400',
            'registered_at' : '4.01.2021 13:00',
            'registered_ip' : '178.912.14.14',
            'gsm' : '0555 555 55 55',
            'birthdate' : '11.12.1999',
            'member_status' : 'Aktif',
            'level1_count' : '0',
            'tc' : '',
            'city_id' : '34',
            'city_name' : 'İstanbul',
            'education_level' : 'Normal Lise',
            'granduation' : 'Öğrenci',
            'parent_city_id' : '',
            'gender' : 'Kadın',
            'marial_status' : 'Bekar',
            'partner_status' : 'N/A',
          },
          {
            'member_id' : '17898',
            'firstname' : 'Bekir',
            'lastname' : 'Uca',
            'email' : 'bekiroca@test.com',
            'point' : '12400',
            'registered_at' : '4.01.2021 13:00',
            'registered_ip' : '178.912.14.14',
            'gsm' : '0555 555 55 55',
            'birthdate' : '11.12.1999',
            'member_status' : 'Aktif',
            'level1_count' : '0',
            'tc' : '',
            'city_id' : '34',
            'city_name' : 'İstanbul',
            'education_level' : 'Normal Lise',
            'granduation' : 'Öğrenci',
            'parent_city_id' : '',
            'gender' : 'Kadın',
            'marial_status' : 'Bekar',
            'partner_status' : 'N/A',
          },
          {
            'member_id' : '17898',
            'firstname' : 'Bekir',
            'lastname' : 'Uca',
            'email' : 'bekiroca@test.com',
            'point' : '12400',
            'registered_at' : '4.01.2021 13:00',
            'registered_ip' : '178.912.14.14',
            'gsm' : '0555 555 55 55',
            'birthdate' : '11.12.1999',
            'member_status' : 'Aktif',
            'level1_count' : '0',
            'tc' : '',
            'city_id' : '34',
            'city_name' : 'İstanbul',
            'education_level' : 'Normal Lise',
            'granduation' : 'Öğrenci',
            'parent_city_id' : '',
            'gender' : 'Kadın',
            'marial_status' : 'Bekar',
            'partner_status' : 'N/A',
          },
        ],
      },
      groups:  [
        {text : 'Ad Soyad', value : "name"},
        {text : 'Kayıt Tarihi', value : "created_at"},
        {text : 'Kayıt IP', value : "created_ip"},
        {text : 'Cep Telefonu', value : "gsm"},
        {text : 'Doğum Tarihi', value : "birthdate"},
        {text : 'Üye Durumu', value : "member_status"},
        {text : 'Ortaklık Durumu', value : "affilate_status"},
      ],
      selected_group : ['name', 'created_at'],

    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_2') },
      { title: this.$t('menu.fraud_management') }
    ]);
  }
}
</script>

<style lang="scss">

</style>
